import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PendingAccess from './PendingAccess';
import KycGate from './KycGate';

export default function ProtectedRoute({ children, admin = false, onboarded = false, kyc = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-farmway-green text-farmway-cream/70">
        <p className="font-display text-sm uppercase tracking-[0.3em]">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  if ((onboarded || kyc) && user.role !== 'admin' && user.status === 'suspended') return <PendingAccess suspended />;
  if ((onboarded || kyc) && user.role !== 'admin' && user.status !== 'onboarded') return <PendingAccess />;
  if (kyc && user.role !== 'admin' && !['submitted', 'approved'].includes(user.kyc?.status)) return <KycGate />;
  return children;
}
